import React, {useContext, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import {BreadcrumbContext} from '../../Breadcrumb';
import { Card, CardContent } from "@mui/material";

const UserPageLayout = (props) => {
    const {
        title,
        children
    } = props

    const { t } = useTranslation();
    const { setBreadcrumb } = useContext(BreadcrumbContext);
    useEffect(() => {
        setBreadcrumb([
            {
                to: "/",
                text: t('common.home'),
                active: false
            },
            {
                to: "/user/profile",
                text: t('nav.profile'),
                active: false
            },
            {
                to: null,
                text: title,
                active: true
            }
        ]);
    },[setBreadcrumb, title, t]);

    return (
        <Card
            sx={{
                backgroundColor: (theme) => theme.custom.card,
                boxShadow: (theme) => theme.custom.cardShadow,
                border: (theme) => `1px solid ${theme.custom.border}`,
            }}
        >
            <CardContent>
                {children}
            </CardContent>
        </Card>
    )
}

export default UserPageLayout;
